import { missingFixtureReasons } from '@/data/missing-fixture-reasons';
import { Box } from '@mui/material';

const JugadoresPartidoInjury = ({ type, reason }) => {
    if (type?.toLowerCase() == 'missing fixture') {
        return (
            <Box
                backgroundColor="#d55f5f"
                color={'#fff'}
                textAlign={'center'}
                borderRadius={0.5}
                fontSize={14}
                margin={'auto'}
                width={'auto'}
                px={1}
                minWidth={120}
            >
                {missingFixtureReasons(reason)}
            </Box>
        );
    } else {
        return (
            <Box
                width={'auto'}
                backgroundColor="#c4a46b"
                color={'#fff'}
                textAlign={'center'}
                borderRadius={0.5}
                fontSize={14}
                px={1}
                minWidth={120}
            >
                {missingFixtureReasons(reason)}
            </Box>
        );
    }
};

export default JugadoresPartidoInjury;
